// Why answers to emergencies were refused, by alert id, re-rendering when that changes.

import { readSosAnswerNotices, subscribeSosAnswerNotices } from '@/services/api/sos-answer-notices'
import { useSyncExternalStore } from 'react'

export function useSosAnswerNotices(): ReadonlyMap<string, string> {
  return useSyncExternalStore(subscribeSosAnswerNotices, readSosAnswerNotices)
}
